import { render, staticRenderFns } from "./BranchOffices.vue?vue&type=template&id=12f4eddc&scoped=true"
import script from "./BranchOffices.vue?vue&type=script&lang=js"
export * from "./BranchOffices.vue?vue&type=script&lang=js"
import style0 from "./BranchOffices.vue?vue&type=style&index=0&id=12f4eddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4eddc",
  null
  
)

export default component.exports